import { render } from "./HeroiconsOutlineEmojiSad.vue?vue&type=template&id=32f9f85e"
const script = {}

import exportComponent from "/Users/dennis/PhpstormProjects/lkm/doc_root/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineEmojiSad.vue"]])

export default __exports__